import gql from 'graphql-tag';
import { isBasicPropertyType as isBasicPropertyType$1, createSingleEntityPickerEditor, createMultipleEntityPickerEditor } from '..';
import React__default, { Component, createElement, Fragment } from 'react';
import { ListItem, ListItemAvatar, Avatar, ListItemText, ListItemSecondaryAction, TextField, FormControl, InputLabel, Select, MenuItem, Checkbox, withStyles, ExpansionPanel, ExpansionPanelSummary, Typography, ExpansionPanelDetails, ExpansionPanelActions, Button, IconButton, createStyles, CircularProgress, Chip, Dialog, DialogTitle, DialogContent, List, DialogActions, ButtonGroup, makeStyles, Link as Link$1, Paper } from '@material-ui/core';
import { pickBy, negate, merge } from 'lodash';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import MomentUtils from '@date-io/moment';
import ChevronRight from '@material-ui/icons/ChevronRight';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import '@material-ui/icons/Event';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Add from '@material-ui/icons/Add';
import { combineContainers } from 'combine-containers';
import { graphql } from 'react-apollo';
import 'pluralize';
import AddCircle from '@material-ui/icons/AddCircle';
import { RichUtils, Entity, SelectionState, CompositeDecorator, EditorState, convertFromRaw, Editor, convertToRaw } from 'draft-js';
import { markdownToDraft, draftToMarkdown } from 'markdown-draft-js';
import { compose } from 'recompose';
import 'react-redux';
import classNames from 'classnames';
import getRangesForDraftEntity from 'draft-js/lib/getRangesForDraftEntity';

function composeSchema(args) {
    return {
        ...args,
        prototypes: {},
    };
}

class GraphqlQueryHelper {
    schemaName(alias) {
        return this.firstLetterToUpper(alias);
    }
    schemaNameForProperty(alias, propertyKey) {
        return `${this.firstLetterToUpper(alias)}${this.firstLetterToUpper(propertyKey)}`;
    }
    getAllQueryWithAllFields(schema) {
        return gql `
      query($filter: ${schema.options.alias}EntityFilterType, $sort: ${schema.options.alias}EntitySortType, $pagination: PaginationType){
        items: ${schema.options.alias}EntityList(filter: $filter, sort: $sort, pagination: $pagination) {
          _id
          ${this.buildPropertiesFromSchema(schema)}
        }
        count: ${schema.options.alias}Count(filter: $filter)
      }
    `;
    }
    buildPropertiesFromSchema(schema) {
        const propertyTypes = Object.keys(schema.properties).reduce((acc, p) => {
            acc[p] = schema.properties[p].type;
            return acc;
        }, {});
        return this.buildProperties(propertyTypes);
    }
    buildProperties(properties) {
        return Object.keys(properties).map((propertyKey) => {
            const propertyType = properties[propertyKey];
            if (isBasicPropertyType$1(propertyType) ||
                (propertyType instanceof Array && isBasicPropertyType$1(propertyType[0]))) {
                return propertyKey;
            }
            else {
                const t = propertyType instanceof Array ? propertyType[0] : propertyType;
                return `
        ${propertyKey} {
          ${this.buildProperties(t)}
        }
        `;
            }
        }).join(`
  `);
    }
    getByIdQueryWithAllFields(schema, id) {
        const propertyTypes = Object.keys(schema.properties).reduce((acc, p) => {
            acc[p] = schema.properties[p].type;
            return acc;
        }, {});
        return gql `
      {
        item: ${schema.options.alias}EntityFindById(id: "${id}") {
          _id
          ${this.buildProperties(propertyTypes)}
        }
      }
    `;
    }
    firstLetterToUpper(s) {
        return s.charAt(0).toUpperCase() + s.slice(1);
    }
}
const graphqlQueryHelper = new GraphqlQueryHelper();

class EntityService {
    constructor() {
        this.instanceDisplayPropsOrDefault = (entitySchema, context) => (entity) => {
            const defaultInstanceDisplayProps = {
                primaryText: entity._id,
                secondaryText: undefined,
                imageUrl: undefined,
            };
            let overrideInstanceDisplayProps;
            try {
                overrideInstanceDisplayProps = pickBy(entitySchema.options.instanceDisplayProps(entity, { context }), negate((a) => !Boolean(a)));
            }
            catch (error) { }
            return merge(defaultInstanceDisplayProps, overrideInstanceDisplayProps);
        };
    }
}
const entityService = new EntityService();

const CoreContext = React__default.createContext({
    serverUrl: '',
    getPluginAxios: null,
    // fileService: new FileService('')
});

const withCoreContext = (Component) => (props) => {
    return React__default.createElement(CoreContext.Consumer, null, (context) => React__default.createElement(Component, Object.assign({}, props, { context: context })));
};

const EntityListItem = (props) => {
    const { schema, entity, context, SecondaryAction } = props;
    const instanceDisplayProps = entityService.instanceDisplayPropsOrDefault(schema, context)(entity);
    const listItemProps = {
        ...props,
    };
    delete listItemProps['SecondaryAction'];
    return (React__default.createElement(ListItem, Object.assign({}, listItemProps),
        React__default.createElement(ListItemAvatar, null,
            React__default.createElement(Avatar, { src: instanceDisplayProps.imageUrl }, schema.options.icon ? React__default.createElement(schema.options.icon, null) : schema.options.alias[0].toUpperCase())),
        React__default.createElement(ListItemText, { primaryTypographyProps: { noWrap: true }, secondaryTypographyProps: { noWrap: true }, primary: instanceDisplayProps.primaryText, secondary: instanceDisplayProps.secondaryText }),
        SecondaryAction && React__default.createElement(ListItemSecondaryAction, null, SecondaryAction)));
};
var EntityListItem$1 = withCoreContext(EntityListItem);

function singleSchemaPicker(schema, options) {
    return {
        ...options,
        type: String,
        editorComponent: createSingleEntityPickerEditor({
            schema,
        }),
        resolverPlugin: {
            alias: 'singleRef',
            meta: { schema },
        },
    };
}
function multipleSchemaPicker(schema, options) {
    return {
        ...options,
        type: [String],
        editorComponent: createMultipleEntityPickerEditor({
            schema,
            max: options.max,
        }),
        resolverPlugin: {
            alias: 'multipleRef',
            meta: { schema },
        },
    };
}
const propertyBuilder = {
    singleSchemaPicker,
    multipleSchemaPicker,
};

function isBasicPropertyType(propertyType) {
    return [String, Number, Date, Boolean].find((t) => propertyType === t);
}

function convertDateToSimpleDate(date) {
    date.setHours(0);
    date.setMinutes(0);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
}

class RenderEditor extends Component {
    render() {
        const { propertyOptions, propertyKey, serverUrl, source } = this.props;
        if (propertyOptions.editorComponent) {
            return (createElement(propertyOptions.editorComponent, { source: source, serverUrl: serverUrl, propertyOptions: propertyOptions, propertyKey: propertyKey, value: this.props.value, setValue: this.props.setValue }));
        }
        else {
            return createElement(Fragment, null);
        }
    }
}

const defaultOptions = {};
var TextEditor = (options = defaultOptions) => (props) => {
    return (createElement(TextField, { multiline: options.multiline, fullWidth: true, inputProps: {
            maxLength: options.maxLength,
        }, label: props.propertyOptions.displayName, value: props.value || '', onChange: (e) => props.setValue(e.target.value) }));
};

var LocationEditor = () => (props) => {
    const value = props.value || {
        lat: 0,
        lng: 0,
    };
    const { lat, lng } = value;
    return (createElement("div", null,
        createElement("input", { value: value.lng, onChange: (e) => props.setValue({
                lat,
                lng: parseInt(e.target.value, 10) || 0,
            }) }),
        createElement("input", { value: value.lat, onChange: (e) => props.setValue({
                lng,
                lat: parseInt(e.target.value, 10) || 0,
            }) })));
};

var SingleDropdownEditor = (options) => (props) => {
    const selectOptions = options ? options.selectOptions || [] : [];
    return (createElement(FormControl, { fullWidth: true },
        createElement(InputLabel, null, props.propertyOptions.displayName),
        createElement(Select, { value: props.value || selectOptions[0], onChange: (e) => props.setValue(e.target.value) }, selectOptions.map((selectOption) => (createElement(MenuItem, { key: selectOption, value: selectOption }, selectOption))))));
};

var MultipleDropdownEditor = (options) => (props) => {
    const selectOptions = options ? options.selectOptions || [] : [];
    const value = props.value || [];
    return (createElement(FormControl, { fullWidth: true },
        createElement(InputLabel, null, props.propertyOptions.displayName),
        createElement(Select, { value: value, fullWidth: true, multiple: true, onChange: (e) => {
                props.setValue(e.target.value.filter((value) => selectOptions.some((option) => value === option)));
            }, renderValue: (e) => {
                if (e instanceof Array) {
                    return `${e.join(', ')}`;
                }
                return '';
            } }, selectOptions.map((selectOption) => {
            const checked = value.some((value) => value === selectOption);
            return (createElement(MenuItem, { key: selectOption, value: selectOption },
                createElement(Checkbox, { checked: checked }),
                createElement(ListItemText, { primary: selectOption })));
        }))));
};

const styles = (theme) => ({
    editor: {
        width: '100%',
    },
});
class DatePickerEditor extends React__default.Component {
    componentDidMount() {
        if (!this.props.value) {
            this.props.setValue(convertDateToSimpleDate(new Date()));
        }
    }
    render() {
        const { classes, value } = this.props;
        return (React__default.createElement(MuiPickersUtilsProvider, { utils: MomentUtils },
            React__default.createElement(DatePicker, { className: classes.editor, allowKeyboardControl: true, label: this.props.propertyOptions.displayName, format: "DD/MM/YYYY", value: value, onChange: (momentDate) => {
                    const newDate = momentDate.toDate();
                    newDate.setHours(0);
                    newDate.setMinutes(0);
                    newDate.setSeconds(0);
                    newDate.setMilliseconds(0);
                    this.props.setValue(newDate);
                }, animateYearScrolling: false, rightArrowIcon: React__default.createElement(ChevronRight, null), leftArrowIcon: React__default.createElement(ChevronLeft, null), showTodayButton: true })));
    }
}
var DatePickerEditor$1 = (options = {}) => withStyles(styles)(DatePickerEditor);

class ListEditor extends React__default.Component {
    constructor() {
        super(...arguments);
        this.state = {
            showAddNewEditor: false,
            stagedValue: undefined,
            expandedIndex: -1,
        };
    }
    render() {
        const { setValue, propertyOptions, propertyKey, serverUrl, source } = this.props;
        const value = this.props.value || [];
        return (React__default.createElement("div", null,
            value.map((v, index) => (React__default.createElement(ExpansionPanel, { expanded: this.state.expandedIndex === index, onChange: (e, expanded) => this.setState({ expandedIndex: expanded ? index : -1 }), key: index },
                React__default.createElement(ExpansionPanelSummary, { expandIcon: React__default.createElement(ExpandMore, null) },
                    React__default.createElement(Typography, null, this.props.displayNameFormat && this.props.displayNameFormat(v, index))),
                React__default.createElement(ExpansionPanelDetails, null,
                    React__default.createElement(this.props.itemComponent, { source: source, serverUrl: serverUrl, propertyOptions: propertyOptions, propertyKey: propertyKey, value: v, setValue: (newValue) => {
                            if (newValue) {
                                const newValues = [...value];
                                newValues[index] = newValue;
                                setValue(newValues);
                            }
                            else {
                                setValue(value.filter((_, i) => index !== i));
                            }
                        } })),
                React__default.createElement(ExpansionPanelActions, null,
                    React__default.createElement(Button, { onClick: () => setValue(value.filter((_, i) => index !== i)) }, "Remove"))))),
            this.state.showAddNewEditor && (React__default.createElement(this.props.itemComponent, { source: source, serverUrl: serverUrl, propertyOptions: propertyOptions, propertyKey: propertyKey, value: this.state.stagedValue, setValue: (newValue) => {
                    this.setState({
                        stagedValue: newValue,
                    });
                } })),
            this.state.showAddNewEditor ? (React__default.createElement("div", null,
                React__default.createElement(Button, { onClick: () => this.setState({
                        showAddNewEditor: false,
                        stagedValue: undefined,
                    }) }, "Cancel add"),
                React__default.createElement(Button, { onClick: () => {
                        const { stagedValue } = this.state;
                        const newValues = [...value, stagedValue];
                        setValue(newValues);
                        this.setState({
                            stagedValue: undefined,
                            showAddNewEditor: false,
                        });
                    } }, "Add item"))) : (React__default.createElement(IconButton, { onClick: () => this.setState({
                    showAddNewEditor: true,
                }) },
                React__default.createElement(Add, null)))));
    }
}
function ListEditor$1 (options) {
    return (props) => React__default.createElement(ListEditor, Object.assign({}, props, options));
}

var SingleEntityPickerEditor = (options) => {
    const MultipleEntityPickerEditor = createMultipleEntityPickerEditor(options);
    return ({ value, setValue, propertyKey, propertyOptions, serverUrl }) => (React__default.createElement(MultipleEntityPickerEditor, Object.assign({ source: {}, serverUrl: serverUrl, value: [value].filter(Boolean), setValue: (newValue) => {
            setValue(newValue[newValue.length - 1]);
        }, propertyKey: propertyKey, propertyOptions: propertyOptions }, options, { max: 1 })));
};

const styles$1 = (theme) => createStyles({
    editor: {
        width: '100%',
    },
    textLink: {
        cursor: 'pointer',
        color: theme.palette.secondary.main,
        '&:hover': {
            textDecoration: 'underline',
        },
    },
    chip: {
        margin: theme.spacing(),
    },
});
class MultipleEntityPickerEditor extends Component {
    constructor() {
        super(...arguments);
        this.state = {
            dialogOpen: false,
        };
        this.handleOnChange = ({ entity }) => () => {
            const { setValue, value, max } = this.props;
            const selectedEntityIds = value || [];
            const checked = this.isChecked({ entity });
            if (checked) {
                setValue(selectedEntityIds.filter((id) => id !== entity._id));
            }
            else if (!max || (value || []).length < max) {
                setValue([...selectedEntityIds, entity._id]);
            }
        };
        this.isChecked = ({ entity }) => {
            const selectedEntityIds = this.props.value || [];
            return selectedEntityIds.some((id) => entity._id === id);
        };
    }
    render() {
        const { classes, value, data, setValue, schema, context, max } = this.props;
        if (data.loading) {
            return createElement(CircularProgress, null);
        }
        const selectedEntityIds = value || [];
        const instanceDisplayProps = entityService.instanceDisplayPropsOrDefault(schema, context);
        return data.items ? (createElement("div", null,
            value ? (createElement(Fragment, null, selectedEntityIds.map((id) => {
                const match = data.items ? data.items.find((entity) => entity._id === id) : undefined;
                const url = match ? instanceDisplayProps(match).imageUrl : undefined;
                return match ? (createElement(Chip, { key: id, avatar: url ? createElement(Avatar, { src: instanceDisplayProps(match).imageUrl }) : undefined, label: instanceDisplayProps(match).primaryText, onDelete: this.handleOnChange({ entity: match }), className: classes.chip })) : (createElement("span", null));
            }))) : (createElement("span", null)),
            (!max || selectedEntityIds.length < max) && (createElement(Chip, { icon: createElement(AddCircle, null), color: "secondary", label: `Select ${schema.options.displayName}`, className: classes.chip, onClick: () => this.setState({ dialogOpen: true }) })),
            createElement(Dialog, { open: this.state.dialogOpen, fullWidth: true, maxWidth: "sm" },
                createElement(DialogTitle, null,
                    "Select a ",
                    schema.options.displayName),
                createElement(DialogContent, null,
                    createElement(List, null, data.items.map((entity) => {
                        return (createElement(EntityListItem$1, { entity: entity, schema: schema, key: entity._id, button: true, onClick: this.handleOnChange({ entity }), SecondaryAction: createElement(Checkbox, { onChange: this.handleOnChange({ entity }), checked: this.isChecked({ entity }) }) }));
                    }))),
                createElement(DialogActions, null,
                    createElement(Button, { onClick: () => this.setState({ dialogOpen: false }) }, "Done"))))) : (createElement("div", null, "None found"));
    }
}
var MultipleEntityPickerEditor$1 = (options) => {
    const ENTITY_PICKER_QUERY = graphqlQueryHelper.getAllQueryWithAllFields(options.schema);
    const Editor = combineContainers(withCoreContext, withStyles(styles$1), graphql(ENTITY_PICKER_QUERY, {
        options: {
            fetchPolicy: 'network-only',
            variables: {
                filter: {},
                sort: {},
                pagination: {
                    limit: 50,
                    skip: 0,
                },
            },
        },
    }))(MultipleEntityPickerEditor);
    return (props) => createElement(Editor, Object.assign({}, props, options));
};

const defaultOptions$1 = { numberType: 'NUMBER' };
var NumberEditor = (options = defaultOptions$1) => (props) => {
    return (createElement(TextField, { multiline: options.multiline, fullWidth: true, inputProps: {
            maxLength: options.maxLength,
        }, label: props.propertyOptions.displayName, value: props.value || '', onChange: (e) => {
            let val = 0;
            if (options.numberType === 'FLOAT') {
                val = parseFloat(e.target.value);
            }
            if (options.numberType === 'NUMBER') {
                val = Number(e.target.value);
            }
            if (options.numberType === 'INT') {
                val = parseInt(e.target.value);
            }
            return props.setValue(val);
        }, type: "number" }));
};

const defaultOptions$2 = { checked: false };
var BooleanEditor = (options = defaultOptions$2) => class extends React__default.Component {
    componentDidMount() {
        if (!this.props.value && this.props.value !== false) {
            this.props.setValue(Boolean(options.checked));
        }
    }
    render() {
        const { value, setValue } = this.props;
        return (React__default.createElement(Checkbox, { checked: value || options.checked, onChange: (e, checked) => {
                return setValue(checked);
            } }));
    }
};

const styles$2 = (theme) => createStyles({
    root: {
        marginBottom: theme.spacing(),
    },
    active: {
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.secondary.contrastText,
        '&:hover': {
            backgroundColor: theme.palette.secondary.light,
        },
    },
    buttonGroup: {
        marginRight: theme.spacing(),
        marginBottom: theme.spacing(),
    },
});
const RteToolbar = (props) => {
    const { classes, setEditorState, editorState } = props;
    const currentStyle = props.editorState.getCurrentInlineStyle();
    const selection = editorState.getSelection();
    const contentState = editorState.getCurrentContent();
    function createBlockButtonProps({ blockType }) {
        return {
            className: classNames({
                [classes.active]: RichUtils.getCurrentBlockType(editorState) === blockType,
            }),
            onClick: () => setEditorState(RichUtils.toggleBlockType(editorState, blockType)),
        };
    }
    function createStyleButtonProps({ inlineStyle }) {
        const currentStyle = props.editorState.getCurrentInlineStyle();
        return {
            className: classNames({
                [classes.active]: currentStyle.has(inlineStyle),
            }),
            onClick: () => setEditorState(RichUtils.toggleInlineStyle(editorState, inlineStyle)),
        };
    }
    const selectionState = editorState.getSelection();
    const start = selectionState.getStartOffset();
    const end = selectionState.getEndOffset();
    const startKey = editorState.getSelection().getStartKey();
    const startOffset = editorState.getSelection().getStartOffset();
    const blockWithLinkAtBeginning = contentState.getBlockForKey(startKey);
    const linkKey = blockWithLinkAtBeginning.getEntityAt(startOffset);
    const selectionKey = selectionState.getAnchorKey();
    const selectionOffset = selectionState.getAnchorOffset();
    const selectedText = blockWithLinkAtBeginning.getText().slice(start, end);
    let url = '';
    if (linkKey) {
        const linkInstance = contentState.getEntity(linkKey);
        url = linkInstance.getData().url;
    }
    function removeSelectedUrl() {
        getRangesForDraftEntity(blockWithLinkAtBeginning, linkKey).forEach((range) => {
            if (range.start <= selectionOffset && selectionOffset <= range.end) {
                const block = contentState.getBlockForKey(selectionKey);
                const blockKey = block.getKey();
                const linkSelection = new SelectionState({
                    anchorOffset: range.start,
                    anchorKey: blockKey,
                    focusOffset: range.end,
                    focusKey: blockKey,
                    isBackward: false,
                    hasFocus: selectionState.getHasFocus(),
                });
                setEditorState(RichUtils.toggleLink(editorState, linkSelection, null));
            }
        });
    }
    const hasLink = Boolean(url);
    function toggleLinkButtonProps() {
        const newUrl = selectedText;
        return {
            className: classNames({
                [classes.active]: hasLink,
            }),
            onClick: () => {
                if (hasLink) {
                    removeSelectedUrl();
                }
                else {
                    if (newUrl.length > 0) {
                        const entityKey = Entity.create('LINK', 'MUTABLE', { url: newUrl });
                        setEditorState(RichUtils.toggleLink(editorState, selection, entityKey));
                    }
                }
            },
        };
    }
    return (React__default.createElement("div", { className: classes.root },
        React__default.createElement(ButtonGroup, { className: classes.buttonGroup, size: "small" },
            React__default.createElement(Button, Object.assign({}, createBlockButtonProps({ blockType: 'unstyled' })), "Normal"),
            React__default.createElement(Button, Object.assign({}, createBlockButtonProps({ blockType: 'header-one' })), "H1"),
            React__default.createElement(Button, Object.assign({}, createBlockButtonProps({ blockType: 'header-two' })), "H2"),
            React__default.createElement(Button, Object.assign({}, createBlockButtonProps({ blockType: 'header-three' })), "H3"),
            React__default.createElement(Button, Object.assign({}, createBlockButtonProps({ blockType: 'header-four' })), "H4"),
            React__default.createElement(Button, Object.assign({}, createBlockButtonProps({ blockType: 'header-five' })), "H5"),
            React__default.createElement(Button, Object.assign({}, createBlockButtonProps({ blockType: 'header-six' })), "H6"),
            React__default.createElement(Button, Object.assign({}, createBlockButtonProps({ blockType: 'blockquote' })), "Quote")),
        React__default.createElement(ButtonGroup, { className: classes.buttonGroup, size: "small" },
            React__default.createElement(Button, Object.assign({}, createStyleButtonProps({ inlineStyle: 'BOLD' })), "Bold"),
            React__default.createElement(Button, Object.assign({}, createStyleButtonProps({ inlineStyle: 'ITALIC' })), "Italic"),
            React__default.createElement(Button, Object.assign({}, createStyleButtonProps({ inlineStyle: 'UNDERLINE' })), "Underline")),
        React__default.createElement(ButtonGroup, { className: classes.buttonGroup, size: "small" },
            React__default.createElement(Button, Object.assign({}, toggleLinkButtonProps()), "Link"),
            hasLink && (React__default.createElement(Chip, { size: "medium", label: url, onDelete: () => {
                    removeSelectedUrl();
                } })))));
};
var RteToolbar$1 = compose(withStyles(styles$2))(RteToolbar);

const useStyles = makeStyles((theme) => ({
    link: {
        textDecoration: 'underline',
    },
}));
const Link = (props) => {
    const data = props.contentState.getEntity(props.entityKey).getData();
    const { url } = data;
    const classes = useStyles(props);
    return (React__default.createElement(Link$1, { className: classes.link, href: url }, props.children));
};

function findLinkEntities(contentBlock, callback, contentState) {
    contentBlock.findEntityRanges((character) => {
        try {
            const entityKey = character.getEntity();
            return entityKey !== null && contentState.getEntity(entityKey).getType() === 'LINK';
        }
        catch (error) { }
    }, callback);
}
const decorator = new CompositeDecorator([
    {
        strategy: findLinkEntities,
        component: Link,
    },
]);

const useStyles$1 = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(),
    },
    'header-one': {
        ...theme.typography.h1,
        margin: theme.spacing(1, 0),
    },
    'header-two': {
        ...theme.typography.h2,
        margin: theme.spacing(1, 0),
    },
    'header-three': {
        ...theme.typography.h3,
        margin: theme.spacing(1, 0),
    },
    'header-four': {
        ...theme.typography.h4,
        margin: theme.spacing(1, 0),
    },
    'header-five': {
        ...theme.typography.h5,
        margin: theme.spacing(1, 0),
    },
    'header-six': {
        ...theme.typography.h6,
        margin: theme.spacing(1, 0),
    },
    unstyled: {
        ...theme.typography.body1,
        margin: 0,
    },
    blockquote: {
        ...theme.typography.body1,
        color: '#828282',
        padding: theme.spacing(1, 2),
        fontStyle: 'italic',
        borderLeft: `${theme.spacing()}px solid ${theme.palette.secondary.light}`,
        marginLeft: 0,
    },
    '@global': {
        '.DraftEditor-editorContainer, .DraftEditor-root, .public-DraftEditor-content': {
            height: 'inherit',
            textAlign: 'initial',
        },
        ".public-DraftEditor-content[contenteditable='true']": {
            W: 'read-write-plaintext-only',
        },
        '.DraftEditor-root': {
            position: 'relative',
        },
        '.DraftEditor-editorContainer': {
            backgroundColor: 'rgba(255, 255, 255, 0)',
            borderLeft: '0.1px solid transparent',
            position: 'relative',
            zIndex: 1,
        },
        '.public-DraftEditor-block': {
            position: 'relative',
        },
        '.DraftEditor-alignLeft .public-DraftStyleDefault-block': {
            textAlign: 'left',
        },
        '.DraftEditor-alignLeft .public-DraftEditorPlaceholder-root': {
            left: '0',
            textAlign: 'left',
        },
        '.DraftEditor-alignCenter .public-DraftStyleDefault-block': {
            textAlign: 'center',
        },
        '.DraftEditor-alignCenter .public-DraftEditorPlaceholder-root': {
            margin: '0 auto',
            textAlign: 'center',
            width: '100%',
        },
        '.DraftEditor-alignRight .public-DraftStyleDefault-block': {
            textAlign: 'right',
        },
        '.DraftEditor-alignRight .public-DraftEditorPlaceholder-root': {
            right: '0',
            textAlign: 'right',
        },
        '.public-DraftEditorPlaceholder-root': {
            color: '#9197a3',
            position: 'absolute',
            zIndex: 1,
        },
        '.public-DraftEditorPlaceholder-hasFocus': {
            color: '#bdc1c9',
        },
        '.DraftEditorPlaceholder-hidden': {
            display: 'none',
        },
        '.public-DraftStyleDefault-block': {
            position: 'relative',
            whiteSpace: 'pre-wrap',
        },
        '.public-DraftStyleDefault-ltr': {
            direction: 'ltr',
            textAlign: 'left',
            marginBottom: theme.spacing(),
        },
        '.public-DraftStyleDefault-rtl': {
            direction: 'rtl',
            textAlign: 'right',
        },
        '.public-DraftStyleDefault-listLTR': {
            direction: 'ltr',
        },
        '.public-DraftStyleDefault-listRTL': {
            direction: 'rtl',
        },
        '.public-DraftStyleDefault-ol, .public-DraftStyleDefault-ul': {
            margin: '16px 0',
            padding: '0',
        },
        '.public-DraftStyleDefault-depth0.public-DraftStyleDefault-listLTR': {
            marginLeft: '1.5em',
        },
        '.public-DraftStyleDefault-depth0.public-DraftStyleDefault-listRTL': {
            marginRight: '1.5em',
        },
        '.public-DraftStyleDefault-depth1.public-DraftStyleDefault-listLTR': {
            marginLeft: '3em',
        },
        '.public-DraftStyleDefault-depth1.public-DraftStyleDefault-listRTL': {
            marginRight: '3em',
        },
        '.public-DraftStyleDefault-depth2.public-DraftStyleDefault-listLTR': {
            marginLeft: '4.5em',
        },
        '.public-DraftStyleDefault-depth2.public-DraftStyleDefault-listRTL': {
            marginRight: '4.5em',
        },
        '.public-DraftStyleDefault-depth3.public-DraftStyleDefault-listLTR': {
            marginLeft: '6em',
        },
        '.public-DraftStyleDefault-depth3.public-DraftStyleDefault-listRTL': {
            marginRight: '6em',
        },
        '.public-DraftStyleDefault-depth4.public-DraftStyleDefault-listLTR': {
            marginLeft: '7.5em',
        },
        '.public-DraftStyleDefault-depth4.public-DraftStyleDefault-listRTL': {
            marginRight: '7.5em',
        },
        '.public-DraftStyleDefault-unorderedListItem': {
            listStyleType: 'square',
            position: 'relative',
        },
        '.public-DraftStyleDefault-unorderedListItem.public-DraftStyleDefault-depth0': {
            listStyleType: 'disc',
        },
        '.public-DraftStyleDefault-unorderedListItem.public-DraftStyleDefault-depth1': {
            listStyleType: 'circle',
        },
        '.public-DraftStyleDefault-orderedListItem': {
            listStyleType: 'none',
            position: 'relative',
        },
        '.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listLTR:before': {
            left: -36,
            position: 'absolute',
            textAlign: 'right',
            width: 30,
        },
        '.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-listRTL:before': {
            position: 'absolute',
            right: -36,
            textAlign: 'left',
            width: 30,
        },
        '.public-DraftStyleDefault-orderedListItem:before': {
            content: "counter(ol0) '. '",
            counterIncrement: 'ol0',
        },
        '.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth1:before': {
            content: "counter(ol1) '. '",
            counterIncrement: 'ol1',
        },
        '.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth2:before': {
            content: "counter(ol2) '. '",
            counterIncrement: 'ol2',
        },
        '.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth3:before': {
            content: "counter(ol3) '. '",
            counterIncrement: 'ol3',
        },
        '.public-DraftStyleDefault-orderedListItem.public-DraftStyleDefault-depth4:before': {
            content: "counter(ol4) '. '",
            counterIncrement: 'ol4',
        },
        '.public-DraftStyleDefault-depth0.public-DraftStyleDefault-reset': {
            counterReset: 'ol0',
        },
        '.public-DraftStyleDefault-depth1.public-DraftStyleDefault-reset': {
            counterReset: 'ol1',
        },
        '.public-DraftStyleDefault-depth2.public-DraftStyleDefault-reset': {
            counterReset: 'ol2',
        },
        '.public-DraftStyleDefault-depth3.public-DraftStyleDefault-reset': {
            counterReset: 'ol3',
        },
        '.public-DraftStyleDefault-depth4.public-DraftStyleDefault-reset': {
            counterReset: 'ol4',
        },
    },
}));
var MarkdownRteEditor = (options = {}) => ({ value, setValue }) => {
    const classes = useStyles$1({});
    const rteValue = value
        ? EditorState.createWithContent(convertFromRaw(markdownToDraft(value)), decorator)
        : EditorState.createEmpty(decorator);
    const [editorState, setLocalEditorState] = React__default.useState(rteValue);
    const setEditorState = (newEditorState) => {
        setLocalEditorState(newEditorState);
        const content = newEditorState.getCurrentContent();
        const newValue = draftToMarkdown(convertToRaw(content));
        setValue(newValue);
    };
    return (React__default.createElement(Paper, { className: classes.root },
        React__default.createElement(RteToolbar$1, { editorState: editorState, setEditorState: setEditorState }),
        React__default.createElement(Editor, { editorState: editorState, onChange: setEditorState, blockStyleFn: (contentBlock) => {
                const type = contentBlock.getType();
                return classes[type];
            } })));
};

function buildConfig(config) {
    const schema = [];
    schema.push(...config.schema);
    if (config.plugins) {
        config.plugins.forEach((plugin) => {
            schema.push(...plugin.schema);
        });
    }
    return {
        schema,
    };
}

export { CoreContext, EntityListItem$1 as EntityListItem, RenderEditor, buildConfig, composeSchema, convertDateToSimpleDate, BooleanEditor as createBooleanEditor, DatePickerEditor$1 as createDatePickerEditor, ListEditor$1 as createListEditor, LocationEditor as createLocationEditor, MarkdownRteEditor as createMarkdownRteEditor, MultipleDropdownEditor as createMultipleDropdownEditor, MultipleEntityPickerEditor$1 as createMultipleEntityPickerEditor, NumberEditor as createNumberEditor, SingleDropdownEditor as createSingleDropdownEditor, SingleEntityPickerEditor as createSingleEntityPickerEditor, TextEditor as createTextEditor, graphqlQueryHelper, isBasicPropertyType, propertyBuilder, withCoreContext };
//# sourceMappingURL=index.js.map
